const binding = { modules: {}, dataActions: {} };

    (binding.modules['password-reset'] = {
        c: () => require('@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset/password-reset'),
        $type: 'contentModule',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'password-reset',
        p: 'account-management',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['@msdyn365-commerce-modules|account-management|modules|password-reset|password-reset'] = {
                c: () => require('@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset/password-reset.view.js'),
                cn: '@msdyn365-commerce-modules-account-management-password-reset'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };